<template>
  <div class="day-events">
    <div class="day-event has-background-white is-border is-margin-bottom-xsmall">
      <div class="columns is-gapless is-marginless">
        <div class="column is-narrow is-padding-left is-padding-right-large has-text-right is-border-right is-flex">
          <div class=" is-self-centered">
            <p class=" has-text-centered">
              <time :datetime="date.format('DD-MMMM-YYYY')">
                <b>{{ event.end_date | prettyTime }}</b>
              </time><br>
            </p>
            <span
              style="z-index: 1;"
              class="dot is-medium tooltip is-tooltip-top"
              :class="event.status | dotClass"
              :data-tooltip="optionStatus[event.status].label">
            </span>
          </div>
        </div>
        <div class="column is-padding is-flex">
          <div class="is-self-centered">
            <div>
              <b><router-link :to="{name: 'LotVue', params: {id: event.lot.pk}}">{{ event.lot.ref }}</router-link> - {{ event.program.name }}</b>
            </div>
            <div>
              Déposée par :&nbsp; {{ event.user.last_name }} {{ event.user.first_name }}
            </div>
            <div>
              Contact :&nbsp; {{ event.contact.last_name }} {{ event.contact.first_name }}
            </div>
          </div>
        </div>
        <div class="column is-padding is-narrow is-self-centered">
          <div class="field is-grouped">
            <div class="control is-relative">
              <div class="dropdown is-hoverable is-right">
                <div class="dropdown-trigger">
                  <button
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    class="button is-actions is-circle">
                    <span class="icon is-small is-size-4"><i class="far fa-ellipsis-v"></i></span>
                  </button>
                </div>
                <div
                  id="dropdown-menu"
                  role="menu"
                  class="dropdown-menu">
                  <div class="dropdown-content has-text-left">
                    <a
                      v-if="isAdmin && isPromoteur && (event.status !== 'waiting_list')"
                      @click="$store.commit('setQuickview', { mode: 'OPTION_UPDATE_DATE', params: { source: event } })"
                      class="dropdown-item"><span class="icon"><i class="fas fa-pencil"></i></span><span>Modifier échéance</span></a>
                    <a
                      @click="removeOption"
                      class="dropdown-item has-text-danger"><span class="icon"><i class="fas fa-trash"></i></span><span>Annuler l'option</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Error, Quickview, DefaultValues } from '@/mixins'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'CalendarOptionItems',
  filters: {
    dotClass (value) {
      const COLORS = {
        'approved': 'has-background-success',
        'waiting_list': 'has-background-warning',
        'expired': 'has-background-draft',
        'pre_reserved': 'has-background-info',
        'reserved': 'has-background-reserved',
        'sold': 'has-background-sold',
        'canceled': 'has-background-danger',
        'canceled_auto': 'has-background-danger'
      }
      return COLORS[value]
    }
  },
  mixins: [Error, Quickview, DefaultValues],
  props: {
    event: {
      type: Object
    }
  },
  computed: {
    ...mapState(['quickview']),
    ...mapGetters(['isAdmin', 'isManager', 'isPromoteur']),
    /**
       * date
       * @returns {date}
       */
    date () {
      let date = moment(this.event.end_date)
      if (date && date.isValid()) return date
      else return null
    }
  },
  watch: {
    quickview ({ mode, params, results }) {
      if (results && mode === 'OPTION_UPDATE_DATE' && results.option.pk === this.event.pk) {
        let params = {
          end_date: results.date
        }
        this.updateOption(results.option.pk, params, 'L\'option a été mise à jour.')
      }
    }
  },
  methods: {
    /**
       * confirm delete
       * @returns {object}
       */
    confirmDelete () {
      return this.$swal({
        title: 'Annulation option',
        // text: 'Cette action annulera l\'attribution du lot à ce vendeur pour la durée déterminée.',
        text: 'En stoppant vous perdrez le bénéfice de votre option.',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
          // cancelButton: 'button is-primary'
        }
      })
    },
    /**
       * remove option confirmation
       */
    async removeOption () {
      let r = await this.confirmDelete()
      if (r.value) {
        this.cancelOption(this.event.pk, { status: 'canceled' }, 'L\'option a été annulée.')
      }
    },
    /**
       * update option
       * @param {string} id
       * @param {object} data
       * @param {string} text
       */
    async updateOption (id, data, text) {
      try {
        let request = await this.$api.patch(this.$resources.OPTION, id, data)
        await this.$store.dispatch('fetchOption', request.data.pk)
        this.$toasted.global.success(text)
        let date = moment(request.data.end_date)
        let eventPk = id
        let newDate = moment(date).format('DD/MM/YYYY')
        let sourceDate = moment(this.event.end_date).format('DD/MM/YYYY')
        this.$store.commit('removeCalendarEvent', { eventPk, sourceDate, type: 'options' })
        this.$store.commit('addCalendarEvent', { event: request.data, key: newDate, type: 'options' })
        let day = moment(date).format('DD')
        let month = moment(date).format('MM')
        let year = moment(date).format('YYYY')
        this.$router.push({ name: 'CalendarDay', params: { year, month, day, panel: 'options' } })
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
      } catch (err) {
        console.log(err)
        this.$toasted.global.danger('Erreur lors de la modification de l\'option')
      }
    },
    /**
       * cancel option
       * @param {string} id
       * @param {object} data
       * @param {string} text
       */
    async cancelOption (id, data, text) {
      try {
        let request = await this.$api.patch(this.$resources.OPTION, id, data)
        await this.$store.dispatch('fetchOption', request.data.pk)
        this.$toasted.global.success(text)
        let date = moment(request.data.end_date)
        let eventPk = id
        let sourceDate = moment(this.event.end_date).format('DD/MM/YYYY')
        this.$store.commit('removeCalendarEvent', { eventPk, sourceDate, type: 'options' })
        let day = moment(date).format('DD')
        let month = moment(date).format('MM')
        let year = moment(date).format('YYYY')
        this.$router.push({ name: 'CalendarDay', params: { year, month, day, panel: 'options' } })
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
      } catch (err) {
        console.log(err)
        this.$toasted.global.danger('Erreur lors de la modification de l\'option')
      }
    }
  }
}
</script>
